import React, { Component } from 'react';
import { View, Text } from 'react-native';

export default class SearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <View>
        <Text> SearchModal </Text>
      </View>
    );
  }
}
